import { gql } from '@apollo/client';

export const GET_KPIS = gql`
    query GetKpis($opcion: Int!) {
        kpis(opcion: $opcion) {
            success
            error
            valorEsperado {
                idKpi
                nombre
                descripcion
                link
                activo
            }
        }
    }
`;